// Modules
import cn from 'classnames';

// Types
import type { TModalHeaderProps } from './Modal.type';

// Styles
import styles from './styles.module.scss';

// Components
import Icon from '../Icon';

const ModalHeader = (props: TModalHeaderProps) => {
	const {
		className,
		leftIcon,
		leftIconClassName,
		noCloseButton,
		onClose,
		rightIcon,
		rightIconClassName,
		title,
		titleClassName,
		...restProps
	} = props

	const modalHeaderCN = cn(styles.legion_modal_header, className)
	const leftIconCN = cn(styles.left_icon, leftIconClassName)
	const rightIconCN = cn(styles.right_icon, rightIconClassName)
	const closeButtonCN = cn(styles.close_button)
	const titleCN = cn(styles.title, titleClassName)

	const handleClose = () => {
		onClose?.()
	}

	return (
		<div className={modalHeaderCN} {...restProps}>
			{leftIcon && <span className={leftIconCN}>{leftIcon}</span>}
			<p className={titleCN}>
				{title}
			</p>
			{rightIcon && <span className={rightIconCN}>{rightIcon}</span>}
			{!noCloseButton && (
				<button className={closeButtonCN} onClick={handleClose}>
					<Icon icon={'close'} style={{ backgroundColor: 'var(--Modal-color-right-icon)' }} />
				</button>
			)}
		</div>
	)
}

export default ModalHeader;
